<template>
    <div class="skill_main">
        <div class="skill-banner">
            <img src="../../assets/images/banner6.png" alt="">
            <!-- <div class="banner_warp">
                <div class="top-text">
                    <p>视频数据智能应用系统</p>
                    <p>有效解决视频监控存储、传输的高成本和低带宽无法传输的问题。</p>
                </div>
            </div> -->
        </div>

        <!-- 图片 -->
        <div class="skill_card">
            <!-- 第1张 -->
             <div class="card_all" id="skilltop">
                <div class="num_card">
                    <p>01</p>
                    <p>视频压缩</p>
                    <p>司马大大在VDMS视频数据管理系统中推出BBW视频编码技术，旨在为高清视频数据的高效压缩提供先进解决方案。BBW视频编码发端于混合编码框架，采用自主研发的深度神经网络预测、人眼感知模型、补偿滤波、智能量化等先进技术，大幅度提高视频压缩比，相比H.264提高约10倍。</p>
                </div>
                <div class="img_card">
                    <img src="../../assets/images/140.png" alt="">
                </div>
             </div>
             <!-- 第2张 -->
            <div class="card_all" id="skillsix">
                <div class="num_card" style="float: right">
                    <p>02</p>
                    <p>视频溯源</p>
                    <p>为了防止视频文件的失泄密，以及实现对视频文件的版权保护，VDMS视频数据管理系统内嵌可见和不可见水印功能。客户点播、下载视频文件时，VDMS服务器将客户端的IP地址、客户编号、客户单位名称等重要信息编辑成明文、二维码等水印形式，以可见或不可见的方式嵌入到视频画面中，保证视频版权的安全。</p>
                </div>
                <div class="img_card" style="float: left">
                    <img src="../../assets/images/144.png" alt="">
                </div>
            </div>
            <!-- 第3张 -->
             <div class="card_all" id="skillrout">
                <div class="num_card">
                    <p>03</p>
                    <p>隐私相机</p>
                    <p>该技术能够在不影响现有监控系统架构和原有视频画质，并且不改变原有视频帧率的前提下，对视频图像中的人脸进行遮挡，可以做到“无漏打”、“无误打”，达到保护人物隐私的目的。对外接口简单易用，可快速与其他系统对接，稳定性高、可靠性强，广泛适用于公安执法，媒体采访等对于隐私保护有要求的监控场所</p>
                </div>
                <div class="img_card">
                    <img src="../../assets/images/142.png" alt="">
                </div>
             </div>
             <!-- 第4张 -->
            <div class="card_all" id="skilltow">
                <div class="num_card" style="float: right">
                    <p>04</p>
                    <p>全屏拼接</p>
                    <p>改变传统视频监控分镜头画面的局限，利用全景相机对监控场景进行360度无死角监控。系统可实现视频画面无缝融合拼接，结合时间同步、画面色差校正等算法，使图像更加清晰自然。再通过公司自有的视频压缩技术对拼接后的视频进行压缩传输，实现对高清全景视频的实时传输与高压缩比存储。</p>
                </div>
                <div class="img_card" style="float: left">
                    <img src="../../assets/images/141.png" alt="">
                </div>
            </div>
            <!-- 第5张 -->
             <div class="card_all" id="skillfive">
                <div class="num_card">
                    <p>05</p>
                    <p>人脸识别</p>
                    <p>实现视频流中人脸检测、关键点定位及人脸识别功能的毫秒级响应，使得人脸识别技术可以在实际场景中实现非配合式快速处理，可广泛应用于地产、安防、交通等领域。</p>
                </div>
                <div class="img_card">
                    <img src="../../assets/images/63.png" alt="">
                </div>
            </div>
             <!-- 第6张 -->
            <div class="card_all" id="skillcar">
                <div class="num_card" style="float: right">
                    <p>06</p>
                    <p>车流分析</p>
                    <p>通过对多路高速道路摄像头数据的实时并行处理，可对车辆颜色、类型、车辆轨迹等车辆信息；以及停车、逆行、拥堵、行人、超速、占用应急车道等高速违法事件进行结构化处理，并写入数据库存储，方便大数据平台调用。当违法事件发生时可实时自动报警，并显示违法事件及相关车辆信息。此外还可以对道路的能见度和车流检量进行测，使高速监控系统更加智能化。</p>
                </div>
                <div class="img_card" style="float: left">
                    <img src="../../assets/images/143.png" alt="">
                </div>
            </div>
            <!-- 第七张 -->
             <div class="card_all" id="skillpre">
                <div class="num_card">
                    <p>07</p>
                    <p>人数统计</p>
                    <p>实时分析监控画面中的人数。通过提取人体躯干特征，提升人数统计精度，显著抵抗人物遮挡、画面明暗、形体变化等因素的影响。系统可对出入口人数进行统计；对监控场景下的群集事件进行预警等。</p>
                </div>
                <div class="img_card">
                    <img src="../../assets/images/65.png" alt="">
                </div>
             </div>
            <!-- 第八张 -->
            <div class="card_all" id="skilltprod">
                <div class="num_card" style="float: right">
                    <p>08</p>
                    <p>广告识别</p>
                    <p>检测视频中广告商的商标，自动统计广告商标在视频中的几个曝光维度：曝光时间、持续时长、曝光位置、画面占比等信息。使得在视频直播的同时直接生成广告商标的曝光报表，便于广告商确定广告投放收益，或对广告投放量进行有效监测。支持对各种广告商标或自定义目标的检测和曝光信息统计。</p>
                </div>
                <div class="img_card" style="float: left">
                    <img src="../../assets/images/66.png" alt="">
                </div>
            </div>
            <!-- 第九张 -->
             <div class="card_all" id="skilllook">
                <div class="num_card">
                    <p>09</p>
                    <p>工作状态监控</p>
                    <p>根据监控视频，通过人体识别，行为识别，人脸识别等相关技术判断某人是否在工位上正常工作。系统可对离岗，睡觉，发呆，不符合工作标准等非正常工作状态进行识别，实现对员工工作状态的统计。</p>
                </div>
                <div class="img_card">
                    <img src="../../assets/images/67.png" alt="">
                </div>
             </div>
        </div>
    </div>
</template>

<script>
import header from "../cuscom/header";
export default {
     created(){
//创建时执行跳转锚点位置
            this.$nextTick(() => {this.getlocal()})
        },
        mounted:function(){
            let that = this;
            that.$nextTick(function(){
                window.addEventListener('scroll',that.handleScroll)
            })
            console.log("mounted")

            // this.$router.afterEach((to, from, next) => {
            //     window.scrollTo(0, 0)
            // })
            
        },
        beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },
        methods:{
            //从我本地找到id
            getlocal(){
                //找到锚点id
                let selectId = localStorage.getItem("toId");
                let toElement = document.getElementById(selectId);
                //如果对应id存在，就跳转
                if(selectId){
                    toElement.scrollIntoView()
                }
            }
        },
        //离开页面进行对localStorage  id销毁，避免其他入口进来有锚点问题
        destroyed(){
            localStorage.setItem("toId",'')
        }
}
</script>

<style>
    /* banner图 */
 .skill-banner {
     width: 100%;
     /* height: 681px; */
 }
 .skill-banner img {
     width: 100%;
     height: 100%;
 }
 .banner_warp {
     position: absolute;
     top: 0px;
     left: 19%;
 }
 .top-text {
     width: 570px;
     position: absolute;
     top: 300px;

 }
 .top-text p:nth-child(1) {
     font-size: 40px;
     color: #ffffff;
 }
 .top-text p:nth-child(2) {
     font-size: 19px;
     color: #ffffff;
     margin-top: 10px;
 }

    /* 卡片 */
    .skill_card {
        /* height: 500px; */
        width: 1200px;
        background: #ffffff;
        margin: 0 auto;
    }
    .card_all {
        height: 520px;
        padding-top: 90px;
    }

    .num_card p:nth-child(1) {
        font-size: 110px;
        color: #333333;
        /* font-family: 'Light'; */
        font-family: 等线;
        margin-top: -40px;
    }
    .num_card p:nth-child(2) {
        margin-top: -20px;
        font-size: 35px;
        color: #333333;
    }
    .num_card p:nth-child(3) {
        font-size: 16px;
        margin-top: 10px;
        line-height: 2;
        /* text-indent: 2em; */
        color: #333333;
    }
    .num_card {
        width: 550px;
        float: left;
    }

    .img_card {
        float: right;

    }
</style>



// WEBPACK FOOTER //
// src/components/skill/skill.vue